"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var proj4 = require("proj4/lib/core");
exports.proj4 = proj4;
var Proj = require("proj4/lib/Proj");
var toPoint = require("proj4/lib/common/toPoint");
var defs = require("proj4/lib/defs");
var transform = require("proj4/lib/transform");
proj4.defaultDatum = 'WGS84';
proj4.WGS84 = new Proj('WGS84');
proj4.Proj = Proj;
proj4.toPoint = toPoint;
proj4.defs = defs;
proj4.transform = transform;
exports.mercator = defs('GOOGLE');
exports.wgs84 = defs('WGS84');
